import { jsx as H } from "react/jsx-runtime";
import { createContext as j, useState as q, useRef as L, useEffect as $, useCallback as G, useContext as X } from "react";
import I from "@kakao/smoothie-components/BottomSheet";
const W = j({
  bottomSheetBodyRef: { current: null },
  onReRenderChildren: () => {
  }
}), _ = "unmounted", O = "exited", w = "entering", M = "entered", A = "exiting", Z = ({
  open: r,
  duration: o,
  onEnter: s,
  onEntered: m,
  onExit: l,
  onExited: d
}) => {
  const [t, e] = q(_), y = t === _, g = t === w, S = t === M, v = t === A, R = t === O, u = L();
  return $(() => {
    if (r) {
      e(w), clearTimeout(u.current);
      return;
    }
    r || (e(A), clearTimeout(u.current));
  }, [r]), $(() => {
    if (g) {
      s == null || s(), u.current = setTimeout(() => {
        e(M);
      }, o);
      return;
    }
    if (S) {
      m == null || m();
      return;
    }
    if (v) {
      l == null || l(), u.current = setTimeout(() => {
        e(O);
      }, o);
      return;
    }
    R && (d == null || d(), e(_));
  }, [t]), {
    transitionStatus: t,
    setTransitionStatus: e,
    isUnmounted: y,
    isEntering: g,
    isEntered: S,
    isExiting: v,
    isExited: R
  };
}, h = {
  startY: 0,
  movedY: 0
}, k = 400, P = 0.3, F = ({
  open: r,
  duration: o = k,
  onEnter: s,
  onEntered: m,
  onExit: l,
  onExited: d
}) => {
  const t = L(null), e = L(null), y = L(null), g = L(""), {
    transitionStatus: S,
    setTransitionStatus: v,
    isUnmounted: R,
    isEntering: u,
    isEntered: x,
    isExiting: p,
    isExited: C
  } = Z({
    open: r,
    duration: o,
    onEnter: () => {
      t.current && (t.current.style.pointerEvents = "none"), s == null || s();
    },
    onEntered: () => {
      t.current && (t.current.style.pointerEvents = ""), m == null || m();
    },
    onExit: () => {
      t.current && (t.current.style.pointerEvents = "none"), l == null || l();
    },
    onExited: () => {
      t.current && (t.current.style.pointerEvents = ""), d == null || d();
    }
  });
  return $(() => {
    var b, E, Y;
    if (!r || u || p)
      return;
    const N = () => document.activeElement.blur(), U = (n) => {
      var f;
      return (((f = e.current) == null ? void 0 : f.scrollTop) ?? 0) > 0 || h.movedY === 0 && n <= 0;
    }, B = (n) => {
      var D;
      if (!t.current || !e.current)
        return;
      N();
      const a = (D = e.current) == null ? void 0 : D.contains(n.target), f = Math.max(
        n.targetTouches[0].clientY - h.startY,
        0
      );
      if (a && U(f)) {
        h.startY = n.targetTouches[0].clientY, e.current.style.overflow = "";
        return;
      }
      h.movedY = f, e.current.style.overflow = "hidden", t.current.style.transform = `translateY(${f}px) translateZ(0px)`, t.current.style.transition = "transform 0s linear";
    }, i = () => {
      !t.current || !e.current || (t.current.clientHeight * P < h.movedY ? v(A) : h.movedY !== 0 && (t.current.style.transform = "translateY(0)"), h.startY = 0, h.movedY = 0, e.current.style.overflow = "", t.current.style.willChange = "", t.current.style.transition = g.current, t.current.removeEventListener("touchmove", B), t.current.removeEventListener("touchend", i));
    }, T = (n) => {
      t.current && (h.startY = n.targetTouches[0].clientY, t.current.style.willChange = "transform", g.current = t.current.style.transition, t.current.addEventListener("touchmove", B, {
        passive: !0
      }), t.current.addEventListener("touchend", i, {
        passive: !0
      }));
    };
    return (b = t.current) == null || b.addEventListener("touchstart", T, {
      passive: !0
    }), y.current = (E = e.current) == null ? void 0 : E.querySelector(
      "iframe"
    ), (Y = y.current) == null || Y.addEventListener(
      "load",
      () => {
        var n, a;
        (a = (n = y.current) == null ? void 0 : n.contentDocument) == null || a.addEventListener(
          "touchstart",
          T,
          { passive: !0 }
        );
      },
      { once: !0 }
    ), () => {
      var n, a, f;
      (n = t.current) == null || n.removeEventListener("touchstart", T), (f = (a = y.current) == null ? void 0 : a.contentDocument) == null || f.removeEventListener(
        "touchstart",
        T
      );
    };
  }, [r, u, p]), {
    bottomSheetRef: t,
    bottomSheetBodyRef: e,
    transitionStatus: S,
    isUnmounted: R,
    isEntering: u,
    isEntered: x,
    isExiting: p,
    isExited: C
  };
}, J = () => {
  const [, r] = q(0);
  return { forceRender: G(() => {
    r((s) => (s + 1) % 1e3);
  }, []) };
}, K = I.Body, Q = (r) => {
  const { bottomSheetBodyRef: o, onReRenderChildren: s } = X(W);
  return $(() => {
    s();
  }, [r.children]), /* @__PURE__ */ H(K, { ref: o, ...r });
}, V = I.Header, tt = ({
  showHandleBar: r = !0,
  ...o
}) => /* @__PURE__ */ H(V, { showHandleBar: r, ...o }), c = 400, z = 44, et = {
  entering: {
    transform: "translateY(0)",
    transition: `transform ${c}ms, height ${c}ms ease-in-out`
  },
  entered: {
    transform: "translateY(0)",
    transition: `transform ${c}ms, height ${c}ms ease-in-out`
  },
  exiting: {
    transform: "translateY(100%)",
    transition: `transform ${c}ms, height ${c}ms ease-in-out`
  },
  exited: { transform: "translateY(100%)" },
  unmounted: { transform: "translateY(100%)" }
}, rt = {
  entering: {
    transition: `opacity ${c}ms cubic-bezier(0.52, 0, 0.64, 1)`,
    opacity: 1
  },
  entered: {
    transition: `opacity ${c}ms cubic-bezier(0.52, 0, 0.64, 1)`,
    opacity: 1
  },
  exiting: {
    transition: `opacity ${c}ms cubic-bezier(0.36, 0, 0.64, 1)`,
    opacity: 0
  },
  exited: {
    transition: `opacity ${c}ms cubic-bezier(0.36, 0, 0.64, 1)`,
    opacity: 0
  },
  unmounted: {
    opacity: 0
  }
}, nt = ({
  open: r,
  showFullView: o,
  onEnter: s,
  onEntered: m,
  onExit: l,
  onExited: d,
  onClickDimmed: t,
  children: e,
  ...y
}) => {
  const {
    bottomSheetRef: g,
    bottomSheetBodyRef: S,
    transitionStatus: v,
    isUnmounted: R,
    isEntering: u,
    isExiting: x,
    isExited: p
  } = F({
    open: r,
    duration: c,
    onEnter: s,
    onEntered: m,
    onExit: l,
    onExited: d
  }), { forceRender: C } = J(), N = (i) => {
    i.target === i.currentTarget && (u || x || t == null || t(i));
  }, U = G(
    (i) => {
      const T = g.current ?? i, b = document.querySelector(".modal_header"), E = S.current, Y = document.querySelector(".modal_foot");
      if (!T || !E) return;
      const n = ((b == null ? void 0 : b.scrollHeight) ?? 0) + E.scrollHeight + ((Y == null ? void 0 : Y.scrollHeight) ?? 0), a = o || n > window.innerHeight - z ? window.innerHeight - z : n;
      T.style.height = `${a}px`;
    },
    [o]
  ), B = (i) => {
    g.current = i, U(i);
  };
  return !r && (R || p) ? null : /* @__PURE__ */ H(
    I,
    {
      ref: B,
      style: et[v],
      dimmedStyle: rt[v],
      showFullView: o,
      onClickDimmed: N,
      ...y,
      children: /* @__PURE__ */ H(
        W.Provider,
        {
          value: {
            bottomSheetBodyRef: S,
            onReRenderChildren: C
          },
          children: e
        }
      )
    }
  );
}, ct = Object.assign(nt, {
  ...I,
  Header: tt,
  Body: Q
});
export {
  ct as default
};
